import { RESTCalls } from '../helpers/restcalls';
export namespace WOSpecialty {
    export async function getAllWOSpecialties(token: string,host:any) {
        return fetch(host+'/api/personnel/getWOSpecialties?token=' + token);
    }
    export class WOSpecialtyItemResponse {
        public id: number;
        public literal: string;
        constructor() {
            this.id = -1;
            this.literal = '';
        }
    }
}
